import Vue from 'vue';

import bugsnag from 'bugsnag-js';
const hostname = window.location.hostname;

const hostnames = ['pelican.devv.be','pierre.pelican.devv.be', 'agenda.pelicanjobs.com'];

if (hostnames.includes(hostname)) { // IMPROVEMENT: try to export prod domain ?
    const bugsnagClient = bugsnag({
        apiKey: '3bd708d14cbf174652957416f3c39038', // IMPROVEMENT: export api key ?
        releaseStage: hostname,
        appVersion: '__APP_VERSION__' // app version will be injected at deploy time
    });
    const bugsnagVue = require('bugsnag-vue');
    bugsnagClient.use(bugsnagVue(Vue));
    Vue.prototype.$bugsnagClient = bugsnagClient;
    // now, in your components, you can use "this.bugsnagClient.notify('some error')" to explicitly notify errors, for example in a catch clause
} else {
    Vue.prototype.$bugsnagClient = {
        notify(error) {
            console.error(error);
        }
    };
}

import App from './App.vue'
import allTranslations from './translations';
window.allTranslations = allTranslations;

Vue.config.productionTip = false;

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

import transFilter from 'vue-trans';
Vue.use(transFilter);

import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo);

import ToggleButton from 'vue-js-toggle-button';
Vue.use(ToggleButton);

import vueVisibilityChange from 'vue-visibility-change';
Vue.use(vueVisibilityChange);

import Nl2br from 'vue-nl2br';
Vue.component('nl2br', Nl2br);

import VueTippy from 'vue-tippy';
Vue.use(VueTippy);


import VueJsDatePicker from 'vuejs-datepicker';
Vue.use(VueJsDatePicker);
// import moment core, without locales

//import moment from 'moment';
import moment from 'moment-timezone'
moment.tz("Europe/Brussels");
Object.defineProperty(Vue.prototype, '$moment', {value: moment});

// import wanted locales (these imports seems to be unused, but they are really needed for translations)
import momentFr from 'moment/locale/fr';
import momentEn from 'moment/locale/en-gb';
import momentNl from 'moment/locale/nl';
import momentDE from 'moment/locale/de';
import momentSV from 'moment/locale/sv';
import momentPL from 'moment/locale/pl';
import momentIT from 'moment/locale/it';
import momentDA from 'moment/locale/da';
import momentES from 'moment/locale/es';

import router from './router';

// globally available filters
Vue.filter('Upper', value => value.toUpperCase());
Vue.filter('Truncate', (value, length) => value.substring(0, length) + '…');
Vue.filter('DateFormat', (date, format) => moment(date.date).format(format));
Vue.filter('Round', (value) =>  Math.round(value * 100) / 100);

import currency from './modules/currency';
Object.defineProperty(Vue.prototype, '$currency', {value: currency});

Vue.config.productionTip = false;

import api from './modules/api';
Object.defineProperty(Vue.prototype, '$api', {value: api});

Object.defineProperty(
    Vue.prototype,
    '$absoluteAssetPath',
    {
        value: image => {
            return process.env.VUE_APP_API_BASE_URL_ASSETS + '/images/sources/' + image;
        }
    }
);

let vueApp = null;
function mountVueApp() {
    vueApp = new Vue({
        router,
        render: h => h(App)
    }).$mount('#app');
}
mountVueApp();

// TODO PIERRE: remove that when deploying in production ?
// debug-intended: when hitting ctrl-h, destroy and re-create vue app
document.addEventListener('keydown', function(keyboardEvent) {
    if (keyboardEvent.ctrlKey && keyboardEvent.key === 'h') {
        vueApp.$destroy();
        document.querySelector('.app-container').remove();
        var appDiv = document.createElement('div');
        appDiv.id = 'app';
        document.body.appendChild(appDiv);
        mountVueApp();
    }
});


if ('createTouch' in document) {
    try {
        var ignore = /:hover/;
        for (var i = 0; i < document.styleSheets.length; i++) {
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) {
                continue;
            }
            for (var j = sheet.cssRules.length - 1; j >= 0; j--) {
                var rule = sheet.cssRules[j];
                if (rule.type === CSSRule.STYLE_RULE && ignore.test(rule.selectorText)) {
                    sheet.deleteRule(j);
                }
            }
        }
    }
    catch(e) {
    }
}



